import { render, staticRenderFns } from "./MYMain.vue?vue&type=template&id=31930590"
import script from "./MYMain.vue?vue&type=script&lang=js"
export * from "./MYMain.vue?vue&type=script&lang=js"
import style0 from "./MYMain.vue?vue&type=style&index=0&id=31930590&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports